import axios from 'axios';
import JSZip from 'jszip';
import { enqueueSnackbar } from '../design-system';
import { MESSAGES } from '../const';

export const downloadBlob = (blobObj: any, name: string) => {
  const anchorElement: any = document.createElement('a');

  const url = window.URL.createObjectURL(blobObj);
  anchorElement.href = url;
  anchorElement.download = name;

  document.body.appendChild(anchorElement);
  anchorElement.click();
  window.URL.revokeObjectURL(url);

  anchorElement.remove();
};

export const createZipFromImages = (images: any[]) => {
  const zip = new JSZip();
  const promises: any = [];

  images.forEach((image) => {
    const promise = axios
      .get(image.url, { responseType: 'blob' })
      .then((res) => res.data)
      .then((blob) => {
        zip.file(image.name, blob);
      });

    promises.push(promise);
  });

  return Promise.all(promises).then(() => {
    return zip.generateAsync({ type: 'blob' });
  });
};

export const createFilesFromImages = (images: any[]) => {
  const promises: any = [];

  images.forEach((image) => {
    const promise = axios
      .get(image.url, { responseType: 'blob' })
      .then((res) => res.data)
      .then((blob) => {
        return new File([blob], image.name, { type: blob.type });
      });

    promises.push(promise);
  });

  return Promise.all(promises);
};

export const shareFiles = async (files: any, containerNumber: string) => {
  if (!navigator.canShare || !navigator.canShare({ files })) {
    return enqueueSnackbar(MESSAGES.SHARE.API_NOT_SUPPORTED, 'error');
  }

  await navigator
    .share({
      title: MESSAGES.SHARE.SUCCESS.TITLE_IMAGES,
      text: containerNumber,
      files,
    })
    .catch((err) => {
      if (err.name === 'AbortError') return;

      enqueueSnackbar(MESSAGES.SHARE.API_NOT_SUPPORTED, 'error');
    });
};
